// import {PdfNavigation,PdfsNavigation,ResumeFsm} from '@/store/modules/fsm/messages';
// import router from '@/router/index';

// export default ({tree,parent,api}) => {
//   if(!tree)
//   { //our state is 'active'.  _lib added it
//     let {addState,PseudoStateKind} = api;
//     let here = parent.active;
//     addState('init',here,PseudoStateKind.ShallowHistory);
//   }
//   else
//   {
//     let { messageIs, nextRouterHook, navigate } = api;
//     let here = parent.active;

//     here.init
//       .to(here.pdfs);
//     here.pdfs
//       .to(here.pdfs)
//       .when(messageIs(ResumeFsm))
//       .effect(navigate(PdfsNavigation,
//         (function() {
//           let x = router.currentRoute.params.selectedPdf === undefined ?
//           {} : { selectedPdf: Number(router.currentRoute.params.selectedPdf) };
//           x = JSON.parse(JSON.stringify(x));
//           return x;
//          })()));
         
// ;//      .effect(navigate(PdfsNavigation)); 
//     }
// };
import { PdfNavigation, PdfsNavigation, ResumeFsm } from '@/store/modules/fsm/messages';
import router from '@/router/index';

export default ({ tree, parent, api }) => {
  if (!tree) {
    // our state is 'active'. _lib added it
    let { addState, PseudoStateKind } = api;
    let here = parent.active;
    addState('init', here, PseudoStateKind.ShallowHistory);
  } else {
    let { messageIs, nextRouterHook, navigate } = api;
    let here = parent.active;

    here.init
      .to(here.pdfs)
      .when(messageIs(ResumeFsm))
      .effect(navigate(PdfsNavigation, () => {
        // Ensure that currentRoute and its params exist before reading 'selectedPdf'
        const params = router.currentRoute?.params || {};
        // If 'selectedPdf' is not defined, default to an empty object
        let x = params.selectedPdf === undefined ? {} : { selectedPdf: Number(params.selectedPdf) };
        // Deep clone if necessary (to avoid reference issues)
        x = JSON.parse(JSON.stringify(x));
        return x;
      }));
  }
};

